import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux'
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css'
import { mint } from '../../module/action/user-task';
import Web3 from 'web3';

window.Buffer = window.Buffer || require('buffer').Buffer;
function MintModals({ show,
    setShow,
    handleClose,
    handleShow }) {
    const dispatch = useDispatch()
    const [value, setValue] = useState(1);
    const [valueArr, setValueArr] = useState([1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100])
    const mintLoader = useSelector(e => e.User.mintLoader)
    const metaMaskAccount = useSelector(e => e.User.metaMaskAccount)
    const mintPrice = useSelector((e) => e.User.mintPrice)
    const [limit, setLimit] = useState(3)

    const earlySale = useSelector((e) => e.User.earlySale)
    const preSale = useSelector((e) => e.User.preSale)
    const publicSale = useSelector((e) => e.User.publicSale)
    const totalSupply = useSelector((e) => e.User.totalSupply)
    const minted = useSelector((e) => e.User.minted)
    const tokensLeft = useSelector((e) => e.User.tokensLeft)
    const balanceOf = useSelector((e) => e.User.balanceOf)
    const [buttonDisable, setButtonDisable] = useState(false)

    useEffect(() => {
        if (earlySale) {
            setLimit(3)
        }
        if (preSale) {
            setLimit(3)
        }
        if (publicSale) {
            setLimit(100)
        }
    }, [earlySale, preSale, publicSale])
   

    useEffect(() => {
        // console.log(value, limit, balanceOf)
        if(value > (limit - balanceOf)){
            setButtonDisable(true)
        }else{
            setButtonDisable(false)
        }
    }, [value, limit])

    return (
        <Modal show={show} onHide={handleClose} className="MintModals">
            {/* <div className='cancelButton' onClick={handleClose}>
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" version="1.1" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"></path><path d="M10.5 4l-2.5 2.5-2.5-2.5-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 2.5-2.5 2.5 2.5 1.5-1.5-2.5-2.5 2.5-2.5z"></path></svg>
            </div> */}
            <Modal.Body>
                <h1>MINT NOW</h1>
                <div className='mintValueTrack'>
                    <InputRange
                        maxValue={100}
                        minValue={1}
                        maxLabel='false'
                        value={value}
                        onChange={value => setValue(Math.round(value))} />
                    {/* <div className='valueDivStops'>
                        {valueArr.map((a, i) => (
                            <span className='stop' style={{ left: `${a - 2}%`, color: a <= value ? 'white' : 'rgba(255, 255, 255, 0.7)' }}></span>
                        ))
                        }
                    </div> */}
                    <div className='valueDiv'>
                        {valueArr.map((a, i) => (
                            <p className='value' style={{ left: `${a - 2}%`, color: a <= value ? 'white' : 'rgba(255, 255, 255, 0.7)' }}>{a}</p>
                        ))
                        }
                    </div>
                </div>
                <button disabled={buttonDisable} class="connectButton btn btn-primary btn-lg" style={{ cursor: "pointer" }} onClick={() => dispatch(mint(metaMaskAccount, value, mintPrice))}>
                    {/* <button  class="connectButton btn btn-primary btn-lg" style={{ cursor: "pointer" }} onClick={() => dispatch(mint(metaMaskAccount, 1, mintPrice))}> */}
                    {mintLoader ?
                        <span class="spinner spinner--quarter"></span>
                        :
                        <>
                            {/* <img src={BUTTONSEPARATE} /> */}
                            Mint for {value * Web3.utils.fromWei(String(mintPrice), 'ether')} ETH
                        </>
                    }
                </button>
                <p className='totalSupply'>{minted} / {totalSupply}</p>
            </Modal.Body>
        </Modal>
    )
}

export default MintModals